import { SocialWebStreamWidget } from 'schemas/SocialWebStreamWidgetSchema'
import { AudienceStreamWidget } from 'schemas/AudienceStreamWidgetSchema'
import { Dashboard } from 'schemas/DashboardSchema'
import { SentenceInfo } from 'schemas/SentenceInfoSchema'
import { createSentenceRetrieval } from 'utils/runSearchUtil'
import { toFilter } from 'utils/widgetUtil'

const createSentenceSearch = (
  widgetSetting: SocialWebStreamWidget | AudienceStreamWidget,
  dashboardData: Dashboard,
  fingerprints: SentenceInfo[],
  fingerprintIndex: number
) => {
  const { sort, selectedTopic, maxSoundbites } = widgetSetting
  const { id: dashboardId, name } = dashboardData
  const filter = toFilter(widgetSetting)

  const sentenceInfos: SentenceInfo[] = fingerprints!
    .slice(fingerprintIndex, fingerprintIndex + maxSoundbites!)
    .map((fingerprint) => fingerprint)!

  return createSentenceRetrieval(
    dashboardId!,
    name!,
    [selectedTopic.topicId!],
    sentenceInfos,
    filter,
    widgetSetting.precision!,
    sort!
  )
}

export default createSentenceSearch
